import React from 'react';
import { Select, MenuItem, Checkbox, ListItemText } from '@mui/material';

import { toSelection } from '../utils/selection';

export { toSelection };

// An option is a plain string, or { value, label, disabled } when the shown
// label differs from the value sent to the server (e.g. review statuses).
export const normalizeOption = (o) => (
  o && typeof o === 'object' ? { value: o.value, label: o.label ?? o.value, disabled: !!o.disabled } : { value: o, label: o, disabled: false }
);

// Multi-select filter for a filter bar: an empty selection means "All".
// Render inside a <FormControl> with a matching <InputLabel>.
export default function MultiSelectFilter({ label, value, options, onChange }) {
  const selected = toSelection(value);
  const opts = (options || []).map(normalizeOption);
  const labelOf = (v) => opts.find((o) => o.value === v)?.label ?? v;
  const handleChange = (e) => onChange({ target: { value: toSelection(e.target.value) } });
  return (
    <Select
      multiple
      value={selected}
      label={label}
      onChange={handleChange}
      renderValue={(vals) => (vals.length <= 2 ? vals.map(labelOf).join(', ') : `${vals.length} selected`)}
      MenuProps={{ PaperProps: { sx: { maxHeight: 360 } } }}
    >
      {opts.map((o) => (
        <MenuItem key={o.value} value={o.value} disabled={o.disabled} dense>
          <Checkbox size="small" checked={selected.includes(o.value)} sx={{ p: 0.5, mr: 1 }} />
          <ListItemText primary={o.label} />
        </MenuItem>
      ))}
    </Select>
  );
}
